import { Icon, type IIconStyles } from '@fluentui/react';
import type { FC, MouseEventHandler } from 'react';

import { useTheme } from '@shared-legacy/ui-kit';

import { getDocsOpenInNewTabButtonIconStyle, getDocsOpenInNewTabButtonStyle } from '../styles/docsProvider.styles';

export type DocsOpenInNewTabButtonProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const DocsOpenInNewTabButton: FC<DocsOpenInNewTabButtonProps> = ({ onClick }) => {
  const theme = useTheme();

  return (
    <button
      type="button"
      aria-label="Open documentation in a new tab"
      title="Open documentation in a new tab"
      onClick={onClick}
      style={getDocsOpenInNewTabButtonStyle(theme)}
      data-test="docs-open-new-tab-button"
    >
      <Icon iconName="OpenInNewWindow" styles={getDocsOpenInNewTabButtonIconStyle(theme) as IIconStyles} />
    </button>
  );
};
